import { applyResolveRound as coreApplyResolveRound } from "@cloudnest/stone-flicking-core-engine/appliers";
import type {
  RandomProvider,
  StoneFlickingCoreConfig,
} from "@cloudnest/stone-flicking-core-engine/types";
import type { StoneFlickingState } from "../types/game-state";
import { wrapCoreState } from "../utils/state-mapper";

export function applyResolveRound(
  state: StoneFlickingState,
  coreConfig: StoneFlickingCoreConfig,
  randomProvider?: RandomProvider,
): StoneFlickingState {
  const nextCoreState = coreApplyResolveRound(
    state.coreState,
    coreConfig,
    randomProvider,
  );
  return wrapCoreState(nextCoreState);
}
